import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Splash = () => import(/* webpackChunkName: "splash" */ '../views/Splash.vue')
const Home = () => import(/* webpackChunkName: "home" */ '../views/Home.vue')

const routes = [
    {
        path: '/',
        name: 'splash',
        component: Splash,
        meta: {
            title: 'LSU Football - 2019 National Champions',
            metaTags: [
                {
                    name: 'description',
                    content: 'Check out the 2019 College Football National Champions'
                },
                {
                    itemprop: 'name',
                    content: 'LSU Football - 2019 National Champions'
                },
                {
                    itemprop: 'description',
                    content: 'Check out the 2019 College Football National Champions'
                },
                {
                    name: 'og:title',
                    content: 'LSU Football - 2019 National Champions'
                },
                {
                    name: 'og:description',
                    content: 'Check out the 2019 College Football National Champions'
                },
                {
                    name: 'og:image',
                    content: 'https://s3.amazonaws.com/lsusports.net/cfp2020/share.png'
                },
                {
                    name: 'twitter:title',
                    content: 'LSU Football - 2019 National Champions'
                },
                {
                    name: 'twitter:description',
                    content: 'Check out the 2019 College Football National Champions'
                },
                {
                    name: 'twitter:image',
                    content: 'https://s3.amazonaws.com/lsusports.net/cfp2020/share.png'
                }
            ]
        }
    },{
        path: '/home',
        name: 'home',
        component: Home,
        meta: {
            transitionName: `slide`,
            title: 'LSU Football - 2019 National Champions',
            metaTags: [
                {
                    name: 'description',
                    content: 'Check out the 2019 College Football National Champions'
                },
                {
                    itemprop: 'name',
                    content: 'LSU Football - 2019 National Champions'
                },
                {
                    itemprop: 'description',
                    content: 'Check out the 2019 College Football National Champions'
                },
                {
                    name: 'og:title',
                    content: 'LSU Football - 2019 National Champions'
                },
                {
                    name: 'og:description',
                    content: 'Check out the 2019 College Football National Champions'
                },
                {
                    name: 'og:image',
                    content: 'https://s3.amazonaws.com/lsusports.net/cfp2020/share.png'
                },
                {
                    name: 'twitter:title',
                    content: 'LSU Football - 2019 National Champions'
                },
                {
                    name: 'twitter:description',
                    content: 'Check out the 2019 College Football National Champions'
                },
                {
                    name: 'twitter:image',
                    content: 'https://s3.amazonaws.com/lsusports.net/cfp2020/share.png'
                }
            ]
        }
    },
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.NODE_ENV === 'production' ? '/cfp2020/' : '/',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition;
        }
        else if (to.hash) {
            return window.scrollTo({
              top: document.querySelector(to.hash).offsetTop,
              behavior: 'smooth'
            })
        } else {
          
            return { x: 0, y: 0 }
        }
      }
})

export default router
